import { createSelector } from 'reselect';
import { transformMapData } from './transformers';

const mapState = (state) => state.map || null;
const filterState = (state) => state.map.selectedFilter || '';
const mapData = (state) => state.map.impactLitters || [];
const getZoom = (state) => state.map.zoom || 1;
const getDimension = (state) =>
    state.map.dimension || { top: 90, bottom: -90, left: -180, right: 180 };

export const getSelectedFilter = createSelector(
    filterState,
    (filterState) => filterState,
);

export const getSelectedZoom = createSelector(getZoom, (getZoom) => getZoom);

export const getSelectedDimension = createSelector(
    getDimension,
    (getDimension) => getDimension,
);

export const isMapFilterRequested = createSelector(
    mapState,
    (mapState) => mapState.litterRequested,
);

export const loadingMoreData = createSelector(
    mapState,
    (mapState) => mapState.hasMoreData,
);

export const getImpactLitters = createSelector(
    [mapData, filterState],
    (mapData, filterState) => transformMapData(mapData, filterState),
);
